import React from "react";
import { FlexCenter } from "../styles";
export var ModalImage = function (_a) {
    var _b = _a.alt, alt = _b === void 0 ? "" : _b, src = _a.src;
    return src ? (React.createElement(FlexCenter, null,
        React.createElement("img", { src: src, alt: alt }))) : null;
};
